import { Tiptap, VueNodeViewRenderer } from '@kvass/rich-text'
import ButtonModal from '../Button.vue'
import Button from './Views/Button.vue'
import Bus from '@/bus'
import { path } from 'ramda'

const { Node, mergeAttributes } = Tiptap

async function handleButtonSave(editor, formData, isEditing) {
  Bus.emit('modal:hide')

  const attrs = {
    label: formData.label,
    href: formData.href,
    'data-cta': formData.theme,
    target: formData.target,
    icon: formData.icon,
  }

  let chain = editor.chain().focus()

  if (isEditing) {
    chain = chain.deleteSelection()
  }

  chain
    .insertContent({
      type: 'button',
      attrs: attrs,
    })
    .run()
}

function customFunc({ editor }) {
  const { state } = editor
  const { selection } = state
  const { from, to } = selection

  const node = state.doc.nodeAt(from)
  const isButtonNode = node && node.type.name === 'button'

  let initialData = {
    label: '',
    type: 'internal',
    theme: 'primary',
    icon: '',
    href: '',
    internalPage: '',
    internalAnchor: '',
    externalUrl: '',
  }

  if (isButtonNode) {
    const attrs = node.attrs
    const href = attrs.href || ''
    const isExternal = href.startsWith('http')

    let page = ''
    let anchor = ''

    if (!isExternal && href) {
      const parts = href.split('#')
      page = parts[0]
      if (parts.length > 1) anchor = '#' + parts[1]
    }

    initialData = {
      label: attrs.label,
      href: href,
      theme: attrs['data-cta'],
      icon: attrs.icon,
      type: isExternal ? 'external' : 'internal',
      externalUrl: isExternal ? href : '',
      internalPage: page,
      internalAnchor: anchor,
    }
  } else {
    initialData.label = state.doc.textBetween(from, to, ' ')
  }

  Bus.emit('modal:show', {
    component: ButtonModal,
    modalProps: { clickaway: true },
    props: {
      initialData,
      onSave: formData => handleButtonSave(editor, formData, isButtonNode),
      ...(path(['RichTextOptions', 'button'], this) || {}),
    },
  })
}

const ButtonNode = Node.create({
  name: 'button',
  group: 'inline',
  inline: true,
  atom: true,
  priority: 2000,

  addAttributes() {
    return {
      label: {
        default: 'Button',
        parseHTML: element => (element.innerText ? element.innerText.trim() : 'Button'),
      },
      'data-cta': {
        default: null,
        parseHTML: element => element.getAttribute('data-cta') || 'primary',
      },
      href: {
        default: null,
      },
      target: {
        default: '_blank',
      },
      icon: {
        default: null,
        parseHTML: element => element.getAttribute('data-icon'),
        renderHTML: attributes => {
          if (!attributes.icon) return {}
          return { 'data-icon': attributes.icon }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'a[data-cta]' }]
  },

  renderHTML({ node, HTMLAttributes }) {
    const { label, ...rest } = HTMLAttributes
    const mergedAttrs = mergeAttributes(this.options.HTMLAttributes, rest)

    return ['a', mergedAttrs, node.attrs.label || node.attrs.label || 'Button']
  },

  addNodeView() {
    return VueNodeViewRenderer(Button)
  },
})

export default {
  stateKey: 'button',
  order: 5,
  icon: ['far', 'square-arrow-right'],
  extension: ButtonNode,
  appearance: {
    menu: true,
    bubble: true,
  },
  customFunc,
}
